import object from '@mailobj-browser/front/js/utils/object.js'
import * as dateSelector from './date/selector/styles.js'
import * as newStyles from './newStyles.js'
import * as xaddrs from './xaddrs/styles.js'
import * as xfiles from './xfiles/styles.js'

const block = 'ea_generics'

export const elements = object(null, {
  actions_bar: `${block}__actions_bar`,
  anchor: `${block}__anchor`,
  animate: `${block}__animate`,
  animated: `${block}__animated`,
  aside_postits: `${block}__aside_postits`,
  badge: `${block}__badge`,
  button: `${block}__button`,
  buttons: `${block}__buttons`,
  buttons_grouped: `${block}__buttons_grouped`,
  button_badge: `${block}__button_badge`,
  button_icon: `${block}__button_icon`,
  button_text: `${block}__button_text`,
  button_toggle: `${block}__toggle`,
  card: `${block}__card`,
  cart: `${block}__cart`,
  cart_expiry: `${block}__cart_expiry`,
  cart_expiry_item: `${block}__cart_expiry_item`,
  cart_item: `${block}__cart_item`,
  cart_item_old_price: `${block}__cart_item_old_price`,
  cart_item_price: `${block}__cart_item_price`,
  cart_label: `${block}__cart_label`,
  cart_not_submittable_info: `${block}__cart_not_submittable_info`,
  cart_value: `${block}__cart_value`,
  child_hideable: `${block}__child_hideable`,
  click_to_copy_button: `${block}__click_to_copy_button`,
  chips_add: `${block}__chips_add`,
  chip: `${block}__chip`,
  chip_content: `${block}__chip_content`,
  chip_value: `${block}__chip_value`,
  chip_delete: `${block}__chip_delete`,
  collapse_is_fullscreen_sm: `${block}__collapse_is_fullscreen_sm`,
  collapse_button: `${block}__collapse_button`,
  collapse_panel: `${block}__collapse_panel`,
  collapse_panel_container: `${block}__collapse_panel_container`,
  collapse_panel_is_open: `${block}__collapse_panel_is_open`,
  completion: `${block}__completion`,
  contact: `${block}__contact`,
  device_camera: `${block}__device_camera`,
  device_camera_container: `${block}__device_camera_container`,
  device_camera_video: `${block}__device_camera_video`,
  device_camera_canvas: `${block}__device_camera_canvas`,
  drop: `${block}__drop`,
  dropdown: `${block}__dropdown`,
  dropdown_list: `${block}__dropdown_list`,
  dropdown_item: `${block}__dropdown_item`,
  dropdown_item_label: `${block}__dropdown_item_label`,
  field: `${block}__field`,
  field_input: `${block}__field_input`,
  fields: `${block}__fields`,
  fieldset: `${block}__fieldset`,
  fieldset_group: `${block}__fieldset_group`,
  fieldset_pattern: `${block}__NEW_fieldset_pattern`,
  has: `${block}__has`,
  help: `${block}__help`,
  icon: `${block}__icon`,
  icon_use: `${block}__icon_use`,
  iframe: `${block}__iframe`,
  iframe_iframe: `${block}__iframe_iframe`,
  keyboard: `${block}__keyboard`,
  library: `${block}__library`,
  library_page: `${block}__library_page`,
  library_counter_increment_pages: `${block}__library_counter_increment_pages`,
  listenable: `${block}__listenable`,
  list_expandable: `${block}__list_expandable`,
  loader: `${block}__loader`,
  modal: `${block}__modal`,
  nav: `${block}__nav`,
  nav_list: `${block}__nav_list`,
  nav_item: `${block}__nav_item`,
  nav_action: `${block}__nav_action`,
  nav_button: `${block}__nav_button`,
  notice: `${block}__notice`,
  // resizer: `${block}__resizer`,
  rte: `${block}__rte`,
  rte_actions: `${block}__rte_actions`,
  rte_advanced_actions: `${block}__rte_advanced_actions`,
  rte_iframe: `${block}__rte_iframe`,
  show_more: `${block}__show_more`,
  scroll_to: `${block}__scroll_to`,
  sidebar: `${block}__sidebar`,
  sidebar_opener: `${block}__sidebar_opener`,
  snackbar: `${block}__snackbar`,
  stack: `${block}__stack`,
  subscription_current: `${block}__subscription_current`,
  table: `${block}__table`,
  table_tbody_cell: `${block}__table_tbody_cell`,
  table_tbody_th: `${block}__table_tbody_th`,
  table_tbody_tr: `${block}__table_tbody_tr`,
  table_td: `${block}__table_td`,
  table_th: `${block}__table_th`,
  table_filters: `${block}__table_filters`,
  table_full: `${block}__table_full`,
  tab: `${block}__tab`,
  tab_panel: `${block}__tab_panel`,
  tab_modal_opener: `${block}__tab_modal_opener`,
  tabs: `${block}__tabs`,
  tabs_navigation: `${block}__tabs_navigation`,
  ...newStyles.elements
})

export const modifiers = object(null, {
  animate: object(null, {
    fade_in: `${elements.animate}-fade_in`,
    rotate_180: `${elements.animate}-rotate_180`,
    shake: `${elements.animate}-shake`,
  }),
  animated: object(null, {
    rotate_180: `${elements.animated}-rotate_180`,
  }),
  button: object(null, {
    light: `${elements.button}-light`,
    is_outline: `${elements.button}-outline`,
    is_ghost: `${elements.button}-ghost`,
    is_primary: `${elements.button}-primary`,
    is_secondary: `${elements.button}-secondary`,
    active: `${elements.button}-active`
  }),
  cart_item_price: object(null, {
    monthly_with_vat: `${elements.cart_item_price}-monthly_with_vat`,
    monthly_without_vat: `${elements.cart_item_price}-monthly_without_vat`,
    total_vat: `${elements.cart_item_price}-total_vat`,
    total_with_vat: `${elements.cart_item_price}-total_with_vat`,
    total_without_vat: `${elements.cart_item_price}-total_without_vat`,
  }),
  cart_label: object(null, {
    sub_duration: `${elements.cart_label}-sub_duration`,
  }),
  cart_value: object(null, {
    sub_duration: `${elements.cart_value}-sub_duration`,
  }),
  child_hideable: object(null, {
    last_item: `${elements.child_hideable}-last_item`,
  }),
  collapse_panel: object(null, {
    open: `${elements.collapse_panel}-open`,
  }),
  device_camera: object(null, {
    off: `${elements.device_camera}-off`,
    on: `${elements.device_camera}-on`,
  }),
  dropdown_item: object(null, {
    selected: `${elements.dropdown_item}-selected`,
  }),
  drop: object(null, {
    droppable: `${elements.drop}-droppable`,
    hover: `${elements.drop}-hover`,
    movable: `${elements.drop}-movable`
  }),
  field: object(null, {
    disabled: `${elements.field}-disabled`,
  }),
  field_input: object(null, {
    checkbox: `${elements.field_input}-checkbox`,
    password: `${elements.field_input}-password`,
    radio: `${elements.field_input}-radio`
  }),
  has: object(null, {
    transition_end: `${elements.has}-transition_end`
  }),
  help: object(null, {
    open: `${elements.help}-open`
  }),
  keyboard: object(null, {
    open: `${elements.keyboard}-open`
  }),
  library_counter_increment_pages: object(null, {
    hide: `${elements.library_counter_increment_pages}-hide`
  }),
  nav_button: object(null, {
    action: `${elements.nav_button}-action`
  }),
  rte_actions: object(null, {
    focused: `${elements.rte_actions}-focused`
  }),
  rte_iframe: object(null, {
    focused: `${elements.rte_iframe}-focused`
  }),
  show_more: object(null, {
    hide: `${elements.show_more}-hide`
  }),
  sidebar: object(null, {
    open: `${elements.sidebar}-open`
  }),
  scroll_to: object(null, {
    end_x: `${elements.scroll_to}-end_x`,
    end_y: `${elements.scroll_to}-end_y`
  }),
  snackbar: object(null, {
    hide: `${elements.snackbar}-hide`
  }),
  stack: object(null, {
    small: `${elements.stack}-small`,
    noGap: `${elements.stack}-no_gap`
  }),
  table_tbody_cell: object(null, {
    listenable: `${elements.table_tbody_cell}-listenable`
  }),
  table_tbody_tr: object(null, {
    hover: `${elements.table_tbody_tr}-hover`
  }),
  ...newStyles.modifiers
})

export const helpers = object(null, {
  dateSelector,
  xaddrs,
  xfiles
})
